import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopalgharcab() {



    const cardData = {

keyword: "Mumbai to Palghar Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Palghar Cab services for local outstation travel, weekend trips, business visits, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving via the Mumbai–Ahmedabad highway route, we ensure a smooth, comfortable, and hassle-free travel experience to Palghar and nearby coastal regions.",

topPlaces: [
    {
        title: "Kelva Beach",
        description:
            "Kelva Beach is one of the most popular beaches near Palghar known for its clean shoreline, calm atmosphere, and scenic sunset views, making it ideal for weekend relaxation."
    },
    {
        title: "Kelva Fort",
        description:
            "Kelva Fort is a historic sea fort surrounded by palm trees and coastal beauty, offering a peaceful spot for photography and exploration near the beach."
    },
    {
        title: "Shirgaon Beach & Fort",
        description:
            "Shirgaon Beach is a serene coastal destination near Palghar along with Shirgaon Fort, known for its historical significance and quiet environment."
    },
    {
        title: "Mahim Beach (Palghar Region)",
        description:
            "Mahim Beach near Palghar is a lesser-crowded beach offering peaceful surroundings and is ideal for nature lovers and quiet outings."
    },
    {
        title: "Dahanu Beach",
        description:
            "Dahanu Beach is famous for its long coastline, chikoo orchards, and relaxed vibe, making it a perfect family getaway near Palghar."
    },
    {
        title: "Aswali Dam",
        description:
            "Aswali Dam is a scenic water reservoir surrounded by greenery, popular for picnic outings and short nature trips from Palghar."
    },
    {
        title: "Tansa Wildlife Sanctuary (Nearby Region)",
        description:
            "Tansa Wildlife Sanctuary is a rich forest reserve near Palghar known for diverse flora, fauna, and nature trails for wildlife enthusiasts."
    },
    {
        title: "Satpati Fishing Village",
        description:
            "Satpati is a major fishing village near Palghar offering insight into coastal livelihood, seafood culture, and traditional fishing activities."
    },
    {
        title: "Kasa Fort",
        description:
            "Kasa Fort is a historical hill fort near Palghar offering trekking opportunities and panoramic views of the surrounding landscape."
    },
    {
        title: "Boisar Industrial Area",
        description:
            "Boisar is an important industrial hub near Palghar, frequently visited for business travel and corporate transportation needs from Mumbai."
    }
],



services: [
{
name: "Mumbai to Palghar Cab",
description: "Mumbai Airport Cab offers Mumbai to Palghar Cab service for safe, comfortable, and reliable travel from Mumbai to Palghar district in Maharashtra. Whether you are travelling for business, family visit, local work, weekend trip, or daily travel needs, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury options. Our professional chauffeurs ensure smooth highway driving, timely pickup, passenger safety, and stress-free journey experience. With doorstep pickup from Mumbai, flexible travel planning, transparent pricing, luggage assistance, and 24x7 support, we make your short and long-distance travel convenient and comfortable."
},
{
name: "Mumbai to Palghar Taxi",
description: "Mumbai to Palghar Taxi service by Mumbai Airport Cab provides dependable intercity transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for business travellers, families, and daily commuters, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth journey from Mumbai to Palghar."
},
{
name: "Mumbai to Palghar Cab Fare",
description: "Mumbai to Palghar Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges and flexible options for one-way and round-trip journeys, ensuring cost-effective and reliable travel."
},
{
name: "Mumbai to Palghar Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Palghar Car Rental service with chauffeur-driven vehicles for short and long-distance travel. Our fleet includes comfortable sedans and spacious SUVs ideal for family trips, business visits, and daily transportation needs. We ensure safe driving, luggage support, and flexible itineraries for a smooth travel experience."
},
{
name: "Mumbai to Palghar One Way Cab",
description: "Mumbai to Palghar One Way Cab service provides affordable travel for passengers who require a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for intercity travel, business trips, and personal visits."
},
{
name: "Mumbai to Palghar Outstation Cab",
description: "Mumbai to Palghar Outstation Cab service offers reliable long-distance transportation with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for stress-free intercity journeys."
},
{
name: "Mumbai to Palghar Local Cab",
description: "Mumbai to Palghar Local Cab service provides convenient transportation within Palghar and nearby areas. Mumbai Airport Cab ensures quick pickup, reliable drivers, and comfortable vehicles for local travel, errands, and short-distance trips."
},
{
name: "Mumbai to Palghar Family Cab",
description: "Mumbai to Palghar Family Cab service provides safe and comfortable transportation for families travelling together. Mumbai Airport Cab ensures spacious vehicles, experienced drivers, luggage-friendly travel, and flexible booking options for a stress-free journey."
},
{
name: "Mumbai to Palghar Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Palghar Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality for both short and long journeys."
},
{
name: "Mumbai to Palghar SUV Cab",
description: "Mumbai to Palghar SUV Cab service provides powerful and comfortable vehicles suitable for highway and city travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for families and groups travelling together."
},
{
name: "Mumbai to Palghar Round Trip Cab",
description: "Mumbai to Palghar Round Trip Cab service offers complete return journey solutions for business visits, family trips, and daily travel needs. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Palghar Travel Service",
description: "Mumbai to Palghar Travel Service provides complete transportation solutions for families, business travellers, and daily commuters. Mumbai Airport Cab ensures safe, comfortable, and well-organized travel with flexible itineraries and professional drivers."
},
{
name: "Mumbai to Palghar Weekend Cab",
description: "Mumbai to Palghar Weekend Cab service offers quick and convenient travel solutions for short weekend trips and family visits. Mumbai Airport Cab ensures flexible booking, comfortable vehicles, and reliable chauffeurs for a smooth travel experience."
},
{
name: "Mumbai to Palghar Budget Cab",
description: "Mumbai to Palghar Budget Cab service offers economical travel solutions without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective transportation."
},
{
name: "Mumbai to Palghar Highway Cab",
description: "Mumbai to Palghar Highway Cab service ensures safe and efficient travel across major highway routes. Mumbai Airport Cab provides experienced chauffeurs, optimized routes, and well-maintained vehicles for smooth intercity journeys."
},
{
name: "Mumbai to Palghar Express Cab",
description: "Mumbai to Palghar Express Cab service provides fast and efficient transportation for urgent travel needs. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely arrival at your destination."
},
{
name: "Mumbai to Palghar Night Cab",
description: "Mumbai to Palghar Night Cab service provides safe and reliable transportation for late-night or early-morning travel. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful journeys."
},
{
name: "Mumbai to Palghar Corporate Cab",
description: "Mumbai to Palghar Corporate Cab service is designed for business professionals and companies requiring reliable transportation. Mumbai Airport Cab ensures punctual service, executive comfort, and professional chauffeurs for smooth corporate travel."
},
{
name: "Mumbai to Palghar Airport Cab",
description: "Mumbai to Palghar Airport Cab service provides convenient pickup and drop between Mumbai Airport and Palghar. Mumbai Airport Cab ensures timely service, luggage assistance, and comfortable vehicles for stress-free airport transfers."
}
],

tableData: [
["Mumbai to Palghar Cab","Mumbai to Palghar Taxi"],
["Mumbai to Palghar Cab Fare","Mumbai to Palghar Car Rental"],
["Mumbai to Palghar One Way Cab","Mumbai to Palghar Outstation Cab"],
["Mumbai to Palghar Local Cab","Mumbai to Palghar Family Cab"],
["Mumbai to Palghar Innova Cab","Mumbai to Palghar SUV Cab"],
["Mumbai to Palghar Round Trip Cab","Mumbai to Palghar Travel Service"],
["Mumbai to Palghar Weekend Cab","Mumbai to Palghar Budget Cab"],
["Mumbai to Palghar Highway Cab","Mumbai to Palghar Express Cab"],
["Mumbai to Palghar Night Cab","Mumbai to Palghar Corporate Cab"]
],














whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Palghar Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Palghar Cab services for business travelers, families, tourists, daily commuters, and corporate professionals seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Convenient Travel Between Mumbai and Palghar",
        WhyChoosedescription: "Our cab service offers hassle-free connectivity for business visits, family functions, industrial travel, weekend trips, and personal journeys between Mumbai and Palghar."
    },
    {
        WhyChooseheading: "Perfect for Business and Industrial Travel",
        WhyChoosedescription: "Palghar is a growing industrial and commercial region attracting business owners, factory visitors, employees, and corporate travelers throughout the year."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, same-day return, round trip, or customized travel itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, punctual service, route expertise, and a comfortable travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Corporate Travelers, and Groups",
        WhyChoosedescription: "From individual travelers and families to business teams and group travelers, we provide suitable vehicle options for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai to Palghar Cabs?",
        answer: "Palghar attracts travelers for industrial visits, business meetings, family functions, tourism, educational purposes, and daily travel requirements."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Palghar?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Palghar travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide same-day return trips?",
        answer: "Yes, customers can choose same-day return journeys depending on their travel schedule and requirements."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many business professionals, factory visitors, employees, and corporate clients use our Mumbai to Palghar Cab services regularly."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate teams, industrial visits, and tour groups."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Can multiple stops be included during the trip?",
        answer: "Yes, customers can customize their itinerary and include MIDC locations, business destinations, sightseeing points, restaurants, and personal stops."
    },
    {
        question: "Is advance booking recommended for Mumbai to Palghar travel?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning."
    },
    {
        question: "How can I book a Mumbai to Palghar Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nikhil Patil",
        feedback:
            "I frequently travel to Palghar for industrial visits and Mumbai Airport Cabs has always provided reliable transportation. The drivers are professional and the vehicles are well maintained.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Bhavna Shah",
        feedback:
            "We booked a cab for a family visit to Palghar and had a wonderful experience. The journey was comfortable, the cab was clean, and the service was excellent throughout.",
        rating: 5
    }
];
































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Palghar Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-palghar-cab.jpg",
"description": "Book Mumbai to Palghar cab service for local and outstation travel, family trips, and business journeys. Mumbai Airport Cabs offers reliable taxi service with professional drivers, comfortable cars, flexible one-way and round-trip options, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-palghar-cab"
}
};









    return (
        <div>

<Helmet>
  <title>Mumbai to Palghar Cab | Local & Outstation Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Palghar cab for local and outstation travel, family trips, and business journeys. Safe and comfortable taxi service with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai to palghar cab, mumbai to palghar taxi, mumbai to palghar cab fare, mumbai to palghar car rental, mumbai to palghar one way cab, mumbai to palghar outstation cab, mumbai to palghar local cab, mumbai to palghar family cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitopalgharcab;